<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Add cash</ion-title>
    @if (!loading) {
      <ion-buttons slot="end">
        <ion-button (click)="add()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (!loading) {
    <ion-grid class="form">
      <ion-row>
        <ion-col>
          <ion-grid class="fieldset">
            @if (supported_currencies && supported_currencies.length > 1) {
              <ion-row>
                <ion-col>
                  <ion-select cancelText="Cancel" okText="OK" interface="alert" [interfaceOptions]="currency_options" label="Currency" labelPlacement="stacked" fill="outline" [(ngModel)]="params.currency_id">
                    @for (currency of supported_currencies; track currency) {
                      <ion-select-option value="{{currency.id}}">{{currency.title}}</ion-select-option>
                    }
                  </ion-select>
                </ion-col>
              </ion-row>
            }
            <ion-row>
              <ion-col>
                <ion-input #amount_input type="tel" inputmode="decimal" maxlength="10" label="Amount" labelPlacement="stacked" fill="outline" [(ngModel)]="params.price"></ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-textarea type="text" inputmode="text" maxlength="1000" [autoGrow]="true" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="params.note">
                  <div slot="label">Note<ion-text class="optional">optional</ion-text></div>
                </ion-textarea>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>